export const NRP_METHODOLOGY_URL = 'https://staging-tlg.vercel.app/nrp';

export const BOOK_CONSULTATION_CALENDLY_LINK =
  'https://meetings-eu1.hubspot.com/lia-andras/round-robin?uuid=f1139db9-59f0-4d55-abc6-f776bacb672b';
